import * as React from 'react';
import { Helmet } from 'react-helmet';

interface Props {}

export class HeadSection extends React.PureComponent<Props> {
  render(): React.ReactNode {
    return (
      <Helmet>
        <title>Free Wedding Website Templates—Design the Perfect Look—Joy</title>
        <meta
          name="description"
          content="Choose a free wedding website template that matches your theme—mix and match layouts and designs to create a unique look. Makes yours in minutes!"
        />
        <style type="text/css">
          {`
      html {
        font-size: 16px;
      }
      body {
        font-size: 1rem;
      }
    `}
        </style>
      </Helmet>
    );
  }
}
